import { render, staticRenderFns } from "./PressContents.vue?vue&type=template&id=7c7b191c&scoped=true"
import script from "./PressContents.vue?vue&type=script&lang=js"
export * from "./PressContents.vue?vue&type=script&lang=js"
import style0 from "./PressContents.vue?vue&type=style&index=0&id=7c7b191c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7b191c",
  null
  
)

export default component.exports